import React, { Component } from "react";
import { connect } from "react-redux";
import ForgotPassword from "./../components/ForgotPassword";
import actions from "./../actions";
import { PropTypes } from "prop-types";
import Validators from "./../../shared/utils/Validators";
import _ from "./../../shared/utils/ObjectUtils";
import { I18n } from 'react-redux-i18n';

class ForgotPasswordContainer extends Component {
    constructor() {
        super();
        this.state = {
            email: {
                value: "",
                error: null
            }
        };
    }

    validateEmail = () => {
        const { email } = this.state;
        const value = email.value;
        email.error = Validators.email(value) ? null : I18n.t('auth.errors.invalidEmail');
        this.setState({ email });
    };

    handleEmailDataChanged = value => {
        const { email } = this.state;
        email.value = value;
        this.validateEmail();
    };

    handleSubmit = () => {
        const { email } = this.state;
        if (_.isNilOrEmpty(email.error)) {
            this.props.forgotPassword(email.value);
        } else {
            this.setState({ email });
        }
    };

    render() {
        const { email } = this.state;
        return (
            <ForgotPassword
                {...this.props}
                email={email}
                handleEmailDataChanged={this.handleEmailDataChanged}
                handleFieldBlur={this.validateEmail}
                handleSubmit={this.handleSubmit}
            />
        );
    }
}

ForgotPasswordContainer.propTypes = {
    handleCollapseForgotPasswordClicked: PropTypes.func.isRequired
};

const mapStateToProps = ({ authReducer }) => {
    return {
        error: authReducer.forgotPasswordError
    }
}

const mapDispatchToProps = {
    handleCollapseForgotPasswordClicked: actions.collapseForgotPasswordForm,
    forgotPassword: actions.forgotPassword
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordContainer);
